import React 				from 'react';
import ReactDOM			from 'react-dom';
import PropTypes 		from 'prop-types';
import BLComponent 	from '../core/_BLComponent.jsx';

export default class CustomSelect extends BLComponent {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};
	}

	componentDidMount() {
		document.addEventListener('click', (event) => this.clickOutCustomSelect(event));
	}

	clickOutCustomSelect(event) {
		const isCustomSelect = $(event.target).closest(this.customSelect).length == 1;

		if (!isCustomSelect && this.state.isOpen == true) {
			this.setState({isOpen: false});
		}
	}

	componentWillUnmount() 
	{
		super.componentWillUnmount(); 
		document.removeEventListener('click', (event) => this.clickOutCustomSelect(event));
	}

	render() {
		const {classes = '', items, tight = false, selectedIdx = 0} = this.props;
		const selected = items[selectedIdx];

		const listItems = items.map((item, key) => <li key={key} className={"custom-select__list-item" + (selectedIdx == key ? ' custom-select__list-item--active' : '')} onClick={() => this.onSelect(key)}>{item}</li>);

		return (
			<div ref={customSelect => this.customSelect = customSelect} className={"custom-select " + classes + (tight ? ' custom-select--tight' : '')}>
				<div className="custom-select__selected" onClick={() => this.setState({isOpen: !this.state.isOpen})}>
					{selected}
				</div>
				<ul className={"custom-select__list" + (this.state.isOpen ? ' custom-select__list--active' : '')}>
					{listItems}
				</ul>
			</div>
		);
	}

	onSelect(selected) {
		this.setState({isOpen: false});

		this.props.onChangeFunc(selected);
	}
};


CustomSelect.propTypes = {
		classes: PropTypes.string
	, 	items: PropTypes.array
	,	selectedIdx: PropTypes.number
	, 	onChangeFunc: PropTypes.func
	,	tight: PropTypes.bool
}